<template>
  <v-card elevation="0" class="pa-2" v-if="course && course.id">
    <v-card-title class="mb-3">
      <h2><strong>{{course.name}}</strong></h2>
    </v-card-title>

    <v-row cols="12" class="mt-5 ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <h2><strong>Sobre o Curso</strong></h2>
      </v-col>

      <v-col class="my-0 py-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <section v-html="course.aboutTheCourse"></section>
      </v-col>
    </v-row>

    <v-row cols="12" class="mt-5 ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <h2><strong>Suas habilidades ao final do curso</strong></h2>
      </v-col>

      <v-col
          class="my-0 py-0 mt-5"
          cols="12" xs="12" sm="6" md="6" lg="4" xl="4"
          v-for="item in course.skillsAcquired"
          :key="item.id"
      >
        <v-card
          elevation="2"
          class="pa-2 flex-column"
          height="100%"
        >
          <p >
            <strong v-html="item.title"></strong>
          </p>

          <p>
            <span v-html="item.description"></span>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row cols="12" class="mt-5 ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <h2><strong>Este curso é para você que:</strong></h2>
      </v-col>

      <v-col
          class="my-0 py-0 mt-5"
          cols="12" xs="12" sm="6" md="6" lg="4" xl="4"
          v-for="item in course.targetAudiences"
          :key="item.id"
      >
        <v-card
          elevation="2"
          class="pa-2 flex-column"
          height="100%"
        >
          <p >
            <strong v-html="item.title"></strong>
          </p>

          <p>
            <span v-html="item.description"></span>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row cols="12" class="mt-5 ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <h2><strong>Conteúdo programático</strong></h2>
      </v-col>

      <v-col class="my-0 py-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <v-expansion-panels>
          <v-expansion-panel
              v-for="(item,i) in course.contentsProgrammatic"
              :key="i"
          >
            <v-expansion-panel-header>
              {{ item.title }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <span v-html="item.description"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row cols="12" class="mt-5 ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <h2><strong>Pré-requisitos</strong></h2>
      </v-col>

      <v-col class="my-0 py-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <section v-html="course.requirements"></section>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Preço: </strong>
        <span>{{ formatCurrency(course.price) }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Carga horaria: </strong>
        <span>{{ course.totalHours }} horas</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Ativo: </strong>
        <span>{{ course.active ? 'Sim' : 'Não' }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>



    <v-row class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-btn
            elevation="0"
            class="secondary-button"
            width="100%"
            @click="close()"
        >
          <span>Fechar</span>
        </v-btn>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
        <v-btn
            elevation="0"
            class="primary-button"
            width="100%"
            @click="goToRoute()"
        >
          <span>Editar</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Utils from "../../../../Utils/FormatDate";
import Vue from "vue";
import UtilsFormatCurrency from "@/Utils/FormatCurrency";

export default {
  name: "DetailCourse",
  components: {},
  computed: {},

  props: {
    courseId: {type: Number, required: true, default: null}
  },

  created() {
  },

  async mounted() {
  },
  data() {
    return {
      course: Object,
      active: [
        {name: "Não", value: 'false'},
        {name: "Sim", value: true},
      ],
      periods: [
        {name: "Matutino", value: "0"},
        {name: "Vespertino", value: 1},
        {name: "Noturno", value: 2}
      ],
      levels: [
        {name: "Iniciante", value: "0"},
        {name: "Intermediário", value: 1},
        {name: "Avançado", value: 2}
      ],
      daysOfTheWeek: [
        {name: "Domingo", value: 0},
        {name: "Segunda-feira", value: 1},
        {name: "Terça-feira", value: 2},
        {name: "Quarta-feira", value: 3},
        {name: "Quinta-feira", value: 4},
        {name: "Sexta-feira", value: 5},
        {name: "Sábado", value: 6}
      ],
      apiService: new ApiService(),
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    close() {
      this.$emit('close')
    },
    formatDaysOfTheWeek(daysOfTheWeek) {
      return this.daysOfTheWeek.filter(x => daysOfTheWeek.includes(x.value)).map(x => x.name).join(', ')
    },
    formatLevel(level) {
      return this.levels.find(x => x.value == level).name;
    },
    formatPeriod(period) {
      return this.periods.find(x => x.value == period).name;
    },
    formatDate(date) {
      return Utils.momentDay(date);
    },
    formatCurrency(value) {
      return UtilsFormatCurrency.formatCurrency(value);
    },
    async goToRoute() {
      await this.$router.push({
        path: `/cursos-cadastrar`,
        query: {courseId: this.courseId}
      });
    },
    async getCourse() {
      try {
        const {content} = await this.apiService.get(`course/${this.courseId}`,)
        this.course = content

      } catch (e) {

      }
    },
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
#chartRecipeAndOrder {
  width: 100%;
}

#chartPaymentMethod {
  width: 100%;
}

.card-red {
  background: linear-gradient(to bottom, #f54784, #d62828);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

.card-black {
  background: linear-gradient(to bottom, #000000, #666666);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  padding: 10px 15px;
  text-align: left;
}

tr {
  cursor: pointer;
}

th {
  font-weight: bold;
  border-bottom: 2px solid #ddd;
}

/* coluna receita */
td.receita {
  background: linear-gradient(to right, #f8d7da, #f5c6cb);
  text-align: left;
  font-weight: bold;
  color: #333;
}

/* coluna metros */
td.metros {
  background: linear-gradient(to right, #f8d7da, #f1b0b7);
  text-align: left;
  font-weight: bold;
  color: #333;
}

tr:nth-child(even) td {
  background-color: #fafafa;
}

</style>
